import React from 'react'
import CheckboxField from '../../formFields/checkboxField'
import { reduxFormFieldWrapper } from '../reduxFormFieldWrapper'

// For checkbox wrapper, we add one more wrapper to ensure we have a type='checkbox' because
// the reduxFormFieldWrapper relies on it having that and we shouldn't require the consumer
// of this component to know that they need to set type='checkbox'
export default ({ ...props }) => {
  props.type = 'checkbox'
  return reduxFormFieldWrapper(fieldProps => <CheckboxField {...fieldProps} />)(
    props
  )
}
